import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ICustomizationQuestion } from '../../store/slices/customization/customization';

interface Props {
  question: ICustomizationQuestion;
}

class HeaderStyle extends Component<Props> {
  render() {
    const { question } = this.props;
    const { align = 'left' } = question;
    const justifyContent = align === 'center' ? align : align === 'left' ? 'flex-start' : 'flex-end';
    return (
      <style type="text/css" scoped>
        {`
          .content .ui.header.item-title {
            justify-content: ${justifyContent};
          }
          .content .ui.header.item-title .question-title {
            width: 100%;
          }
          .content .ui.header.item-title *, .content .na-checkbox label {
            color: ${question.color} !important;
            font-family: ${question.font};
            text-align: ${question.align || 'left'};
          }
      `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    question: customization.question || {},
  };
};

export default connect(mapStateToProps)(HeaderStyle);
